import { useState, useCallback } from "react";
import { Form, Button } from "react-bootstrap";

const normalizeItem = (item) =>
  typeof item === 'string' ? { id: crypto.randomUUID(), text: item } : item;

export default function BulletListBlock({ data, onChange }) {
  const [items, setItems] = useState(
    () => (data.items?.length ? data.items.map(normalizeItem) : [{ id: crypto.randomUUID(), text: "" }])
  );

  // Local-only updates (no parent spam)
  const handleItemsChangeLocal = useCallback((newItems) => {
    setItems(newItems);
  }, []);

  // Push to parent ONLY when leaving the block
  const handleBlur = useCallback(() => {
    onChange?.({
      ...data,
      items: items,
    });
  }, [items, data, onChange]);

  const addItem = () =>
    handleItemsChangeLocal([
      ...items,
      { id: crypto.randomUUID(), text: "" },
    ]);

  const removeItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    handleItemsChangeLocal(newItems);

    // 🔥 force commit because blur won't fire
    onChange?.({
      ...data,
      items: newItems,
    });
  };

  const updateItem = (index, value) => {
    const newItems = [...items];
    newItems[index] = {
      ...newItems[index],
      text: value,
    };
    handleItemsChangeLocal(newItems);
  };

  return (
    <div
      className="p-3 border rounded bg-white"
      onBlur={(e) => {
        // Only trigger when focus leaves the entire block
        if (!e.currentTarget.contains(e.relatedTarget)) {
          handleBlur();
        }
      }}
    >
      {items.map((item, i) => (
        <div key={item.id || i} className="d-flex align-items-center mb-2">
          <span className="me-2">•</span>

          <Form.Control
            type="text"
            value={item.text}
            onChange={(e) => updateItem(i, e.target.value)}
            placeholder="Kirjoita kohta..."
          />

          <Button
            size="sm"
            variant="outline-danger"
            className="ms-2"
            onClick={() => removeItem(i)}
            disabled={items.length === 1}
          >
            ✕
          </Button>
        </div>
      ))}

      <Button size="sm" variant="outline-primary" onClick={addItem}>
        + Lisää rivi
      </Button>
{/* 
      <div className="mt-4">
        <h6>Active Block Content (debug)</h6>
        <pre>{JSON.stringify(data, null, 2)}</pre>
      </div> */}
    </div>
  );
}